<template>
  <voicemod-key-layout
    data-testid="layout"
    :variant="planType"
  >
    <div class="vm-key-plan-selection">
      <img
        class="vm-key-plan-selection__logo"
        src="./assets/vmkey.png"
        alt="vm key plan selection"
      >

      <h1 class="headline-lg">
        {{ $t('vmkeyPlanSelection.title') }}
      </h1>

      <div class="vm-key-plan-selection__product">
        <div class="vm-key-plan-selection__save-container">
          <span class="vm-key-plan-selection__save">{{ $t('vmkeyPlanSelection.pricing.save') }} {{ currentPrices.saving }}%</span>
          <span class="vm-key-plan-selection__original body-md">${{ currentPrices.original }}</span>
        </div>
        <span class="vm-key-plan-selection__product-title headline-md">
          Only ${{ currentPrices.price }}
          <span v-if="planType === 'free'">
            {{ $t('vmkeyPlanSelection.pricing.yearly') }}
          </span>
        </span>
        <hr>
        <router-link
          :to="{path: '/address-form', query: {
            productId: product[planType].sku,
            isVMKeySub: planType === 'free',
            isVMKeySB: planType === 'pro',
          }}"
          @click.native="trackGetVoicemodKey"
        >
          <base-button
            :customizable="{ maxWidth: '350px' }"
            :is-type="['simple', 'vanish']"
          >
            {{ $t('vmkeyPlanSelection.button') }}
          </base-button>
        </router-link>

        <span
          v-if="planType === 'free'"
          class="vm-key-plan-selection__product-info body-md"
        >
          {{ $t('vmkeyPlanSelection.pricing.free.info') }}
        </span>
        <span
          v-else
          class="vm-key-plan-selection__product-info body-md"
        >
          {{ $t('vmkeyPlanSelection.pricing.pro.info') }}
        </span>
      </div>

      <ul>
        <li
          v-for="(reward, index) in currentRewards"
          :key="index"
        >
          <img
            src="./assets/check.svg"
            alt="check"
          >
          <span class="body-md">
            {{ reward }}
          </span>
        </li>
      </ul>

      <div class="vm-key-plan-selection__terms">
        <span>{{ $t('vmkeyPlanSelection.terms.text') }}</span>
        <a
          href="https://vcmd.link/vmkey-terms"
          target="_blank"
        >
          {{ $t('vmkeyPlanSelection.terms.link') }}
        </a>
      </div>
    </div>
  </voicemod-key-layout>
</template>

<script>
import VoicemodKeyLayout from '@/layouts/VoicemodKeyLayout.vue';
import BaseButton from '@RepoComponent/BaseButton/BaseButton';
import { metricsService } from  '@/metrics/metrics';
import { mParticleMetric } from '../../metrics/mparticle';
import SessionValidation from '../../mixins/SessionValidation/SessionValidation';
import { LOGIN_ACTIONS_CONSTANTS } from '../../domain/login/constants';

export default {
    name: 'VMKeyPlanSelection',
    components: {
        VoicemodKeyLayout,
        BaseButton,
    },
    mixins: [SessionValidation(LOGIN_ACTIONS_CONSTANTS.VM_KEY)],
    data() {
        return {
            sessionUserInfo: {},
            product: {
                free: {
                    sku: process.env.VUE_APP_VMKEY_FREE_SKU,
                },
                pro: {
                    sku: process.env.VUE_APP_VMKEY_PRO_SKU,
                },
            },
            prices: {
                free: {
                    saving: 40,
                    original: 59.99,
                    price: 35.99,
                },
                pro: {
                    saving: 50,
                    original: 49.99,
                    price: 24.99,
                },
            },
            rewards: {
                free: [
                    this.$t('vmkeyPlanSelection.rewards.free.item2'),
                    this.$t('vmkeyPlanSelection.rewards.free.item1'),
                    this.$t('vmkeyPlanSelection.rewards.free.item3'),
                    this.$t('vmkeyPlanSelection.rewards.free.item4'),
                ],
                pro: [
                    this.$t('vmkeyPlanSelection.rewards.pro.item2'),
                    this.$t('vmkeyPlanSelection.rewards.pro.item1'),
                    this.$t('vmkeyPlanSelection.rewards.pro.item4'),
                    this.$t('vmkeyPlanSelection.rewards.pro.item3'),
                ],
            },
        };
    },
    computed: {
        planType() {
            return this.sessionUserInfo?.subscription?.subscriptionType || 'free';
        },
        currentPrices() {
            return this.prices[this.planType];
        },
        saving() {
            return this.currentPrices.saving;
        },
        originalPrice() {
            return this.currentPrices.original;
        },
        discountedPrice() {
            return this.currentPrices.price;
        },
        currentRewards() {
            return this.rewards?.[this.planType] || [];
        },
    },
    mounted() {
        if (sessionStorage.getItem('userInfo')) {
            this.sessionUserInfo = JSON.parse(sessionStorage.getItem('userInfo'));
        }
        this.trackViewVMKeyPlanSelection();
    },
    methods: {
        trackViewVMKeyPlanSelection() {
            const eventData = {
                product_name: this.planType === 'free' ? 'vm-key-free' : 'vm-key-pro',
                product_id: this.product[this.planType].sku,
                original_voicemod_system: 'vm-mobile',
                page_url_full_path: window.location.hash.slice(1),
            };
            metricsService.trackEvent(eventData);
            mParticleMetric.track(
                mParticleMetric.EVENTS.VIEW_VM_KEY_PLAN_SELECTION,
                {
                    page_url_full_path: eventData.page_url_full_path,
                },
                mParticleMetric.EVENT_TYPE.Navigation,
            );
        },
        trackGetVoicemodKey() {
            const eventData = {
                product_name: this.planType === 'free' ? 'vm-key-free' : 'vm-key-pro',
                product_id: this.product[this.planType].sku,
                web_button_name: 'vmkey-add-to-cart',
                original_voicemod_system: 'vm-mobile',
                page_url_full_path: window.location.hash.slice(1),
            };
            metricsService.trackEvent(eventData);
            mParticleMetric.track(
                mParticleMetric.EVENTS.WEB_CLICK, eventData, mParticleMetric.EVENT_TYPE.Navigation,
            );
        },
    },
};
</script>

<style src="./VMKeyPlanSelection.scss" lang="scss" scoped></style>
